export default "__VITE_ASSET__DuCTn1jG__"